import classnames from 'classnames'

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  invalid?: boolean
}

export default function Input({
  className,
  invalid = false,
  ...props
}: InputProps) {
  return (
    <input
      className={classnames(
        'h-11 w-full rounded-md border px-3 text-sm outline-none transition',
        'focus:border-primary focus:ring-2 focus:ring-primary/20',
        invalid
          ? 'border-rose-300 bg-rose-50/50 text-rose-900 placeholder:text-rose-400'
          : 'border-zinc-300 bg-white text-zinc-900',
        className
      )}
      {...props}
    />
  )
}
